import { render, staticRenderFns } from "./DealersView.vue?vue&type=template&id=c88ca364&"
import script from "./DealersView.vue?vue&type=script&lang=js&"
export * from "./DealersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports